import { Autocomplete, Stack, TextField } from '@mui/material'
import { GetCandidateJobBoardQuery } from '__generated__/graphql'
import { FormikProps } from 'formik'
import { FC } from 'react'
import { JobBoardFormValues } from '.'

interface InterestedFormFieldsProps {
    formik: FormikProps<JobBoardFormValues>
    jobBoard?: GetCandidateJobBoardQuery['getCandidateJobBoard']['jobBoard']
    canEdit: boolean
}

const InterestedFormFields: FC<InterestedFormFieldsProps> = ({
    jobBoard,
    formik,
    canEdit,
}) => {
    const sectors = jobBoard?.sectors ?? []
    const locations = jobBoard?.companyOffices ?? []

    return (
        <Stack gap={3} marginTop={4}>
            <Autocomplete
                disabled={formik.values.disabled || !canEdit}
                fullWidth
                multiple
                ChipProps={{ size: 'small' }}
                options={sectors}
                getOptionLabel={(option) => option.sector?.value || ''}
                value={
                    sectors.filter((sector) => {
                        const sectorId = sector?.sector?.id
                        if (!sectorId) return false
                        return formik.values.sectorIds?.includes(sectorId)
                    }) ?? []
                }
                onChange={(event, newValue) => {
                    formik.setFieldValue(
                        'sectorIds',
                        newValue.map((sector) => sector.sector?.id)
                    )
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Preferred Sector(s)"
                        variant="outlined"
                        required
                        error={
                            formik.touched.sectorIds &&
                            Boolean(formik.errors.sectorIds)
                        }
                        helperText={
                            formik.touched.sectorIds && formik.errors.sectorIds
                        }
                    />
                )}
            />
            <Autocomplete
                disabled={formik.values.disabled || !canEdit}
                fullWidth
                multiple
                ChipProps={{ size: 'small' }}
                options={locations}
                getOptionLabel={(option) =>
                    option.companyOffice?.officeLocation?.value || ''
                }
                value={
                    locations.filter((location) => {
                        const locationId = location?.companyOffice?.id
                        if (!locationId) return false
                        return formik.values.locationIds?.includes(locationId)
                    }) ?? []
                }
                isOptionEqualToValue={(option, value) =>
                    option.companyOffice?.id === value.companyOffice?.id
                }
                onChange={(event, newValue) => {
                    formik.setFieldValue(
                        'locationIds',
                        newValue.map((location) => location.companyOffice?.id)
                    )
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Preferred Location(s)"
                        variant="outlined"
                        required
                        error={
                            formik.touched.locationIds &&
                            Boolean(formik.errors.locationIds)
                        }
                        helperText={
                            formik.touched.locationIds &&
                            formik.errors.locationIds
                        }
                    />
                )}
            />
            <TextField
                disabled={formik.values.disabled || !canEdit}
                id="comments"
                label="Additional Comments"
                value={formik.values.interestedComments}
                multiline
                rows={6}
                onChange={(e) =>
                    formik.setFieldValue('interestedComments', e.target.value)
                }
            />
        </Stack>
    )
}

export default InterestedFormFields
